module.exports = __webpack_public_path__ + "img/public/SiteIcons/nonRefund.svg?21512bb8";